<div class="layout-wrapper" (click)="onLayoutClick()"
     [ngClass]="{'layout-wrapper-overlay-sidebar': isOverlay(),
                 'layout-wrapper-slim-sidebar': isSlim(),
                 'layout-wrapper-horizontal-sidebar': isHorizontal(),
                 'layout-wrapper-overlay-sidebar-active': overlayMenuActive,
                 'layout-wrapper-sidebar-inactive': staticMenuDesktopInactive,
                 'layout-wrapper-sidebar-mobile-active': staticMenuMobileActive, 'p-ripple-disabled': !app.ripple, 'p-input-filled': app.inputStyle === 'filled'}">
    <app-topbar></app-topbar>

    <app-megamenu></app-megamenu>

    <div class="layout-sidebar" (click)="onMenuClick($event)"
         [ngClass]="{'layout-sidebar-dark': app.menuMode !== 'light',
         'layout-sidebar-gradient':  app.menuMode === 'gradient'}">
        <div class="sidebar-scroll-content">
            <app-inline-profile *ngIf="app.profileMode=='inline' && !isHorizontal()"></app-inline-profile>
            <app-menu></app-menu>
        </div>
    </div>

    <app-rightpanel></app-rightpanel>

    <div class="layout-main">
        <sf-loader></sf-loader>
        <app-breadcrumb></app-breadcrumb>

        <div class="layout-main-content">
            <router-outlet></router-outlet>
        </div>

        <app-footer></app-footer>
    </div>
asd
    <!-- <app-config></app-config> -->
</div>
